module.exports = __webpack_public_path__ + "img/11.7545beb5.jpg";